import type { FunctionComponent } from 'react'
import React from 'react'
import { GridItem, Jumplinks as SBJumplinks } from '@which/seatbelt'

import styles from './SectionJumpLinks.module.scss'

export const SectionJumpLinks: FunctionComponent<Props> = ({ jumpLinks }) => {
  if (!jumpLinks?.length) {
    return null
  }

  const scrollTo = (id: string) => {
    const header = document.getElementById(id)

    if (header) {
      window.scrollTo({
        top: document.documentElement.scrollTop + header.getBoundingClientRect().top,
        behavior: 'smooth',
      })
      window.history.pushState(null, '', `#${id}`)
    }
  }

  return (
    <GridItem
      key={'grid-item-jumpLinks'}
      span={{ medium: 10, large: 10 }}
      columnStart={{ medium: 2, large: 2 }}
    >
      <SBJumplinks
        items={jumpLinks.map(({ jumpLinkText, jumpLinkId }) => ({
          text: jumpLinkText,
          path: `#${jumpLinkId}`,
          onClick: (event: MouseEvent): void => {
            event.preventDefault()
            scrollTo(jumpLinkId)
          },
        }))}
        title=""
        className={styles.sectionJumpLinks}
      />
    </GridItem>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  jumpLinks: { jumpLinkText: string; jumpLinkId: string }[]
}
